module.exports = __webpack_public_path__ + "img/skyscanner-inline--blue.bab7f182.svg";